
import { FreebiesResponse, empDeptRequest } from '@gtpl/shared-models/canteen-management';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { CompanyIdRequest } from '../company/dto';
import { CompanyIdHoursRequest } from './dto/company-id-hours.request';
import { FreebieIdRequest } from './dto/freebie-id.request';
import { FreebieRequest } from './dto/freebie.dto';
import { FreebiesServices } from './freebies.service';

@ApiTags('freebies')
@Controller('freebies')
export class FreebiesController {
    constructor(
        private freebiesService: FreebiesServices,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ) {}

    /**
     * creates the freebies
     * @param freebiesReq 
     * @returns 
     */
    @Post('/createFreebie')
    async createFreebie(@Body() freebiesReq: FreebieRequest): Promise<FreebiesResponse> {
        try {
            return await this.freebiesService.createFreebie(freebiesReq);
        } catch (error) {
            console.log(error)
            return this.applicationExceptionHandler.returnException(FreebiesResponse, error);
        }
    }
    /**
     * creates the freebies
     * @param freebiesReq 
     * @returns 
     */

    @Post('/getReportData')
    async getReportData(@Body() req?:empDeptRequest): Promise<FreebiesResponse> {
        try {
            return await this.freebiesService.getReportData(req);
        } catch (error) {
            console.log(error)
            return this.applicationExceptionHandler.returnException(FreebiesResponse, error);
        }
    }

    @Post('/updateFreebie')
    async updateFreebie(@Body() freebiesReq: FreebieRequest): Promise<FreebiesResponse> {
        try {
            console.log('&&&&&&',freebiesReq)
            return await this.freebiesService.updateFreebie(freebiesReq);
        } catch (error) {
            console.log(error);
            return this.applicationExceptionHandler.returnException(FreebiesResponse, error);
        }
    }

    /**
     * gets the freebie for a given id
     * @param freebieIdReq 
     */
    @Post('/ActivateorDeactivateFreebies')
    async ActivateorDeactivateFreebies(@Body() freebiesReq: FreebieIdRequest): Promise<FreebiesResponse> {
        try {
            return await this.freebiesService.ActivateorDeactivateFreebies(freebiesReq);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(FreebiesResponse, err);
        }
    }

    /**
     * deactivates the freebie
     * @param freebieIdReq 
     */
    @Post('/deleteFreebieById')
    async deleteFreebieById(@Body() freebieIdReq: FreebieIdRequest): Promise<FreebiesResponse> {
        try {
            return await this.freebiesService.deleteFreebieById(freebieIdReq.freebieId, freebieIdReq.username);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(FreebiesResponse, error);
        }
    }

    /**
     * gets the freebies defined for a company
     * @param companyId 
     */
    @Post('/getFreebiesByCompanyId')
    async getFreebiesByCompanyId(@Body() companyIdReq: CompanyIdRequest): Promise<FreebiesResponse> {
        try {
            return await this.freebiesService.getFreebiesByCompanyId(companyIdReq.companyId);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(FreebiesResponse, error);
        }
    }

    /**
     * gets all the freebies in the system
     */
    @Post('/getAllFreebies')
    async getAllFreebies(): Promise<FreebiesResponse> {
        try {
            return await this.freebiesService.getAllFreebies();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(FreebiesResponse, error);
        }
    }

    /**
     * gets the proper freebie mapped for a given hour
     * @param companyIdHourReq 
     * @returns 
     */
    @Post('/getFreebieForCompanyAndHours')
    async getFreebieForCompanyAndHours(@Body() companyIdHourReq: CompanyIdHoursRequest): Promise<FreebiesResponse> {
        try {
            return await this.freebiesService.getFreebieForCompanyAndHours(companyIdHourReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(FreebiesResponse, error);
        }
    }
    /**
     * get the proper freebie mapped for a given job hour
     * @param companyIdHourReq 
     * @returns 
     */
    @Post('/getFreebieForCurrentJobHour')
    async getFreebieForCurrentJobHour(@Body() companyIdHourReq: CompanyIdHoursRequest): Promise<FreebiesResponse> {
        try {
            return await this.freebiesService.getFreebieForCurrentJobHour(companyIdHourReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(FreebiesResponse, error);
        }
    }

    @Post('/getAllActiveFreebies')
    async getAllActiveFreebies(): Promise<FreebiesResponse> {
        try {
            return await this.freebiesService.getAllActiveFreebies();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(FreebiesResponse, error);
        }
    }

}